import { clientConfig } from "../config/client";

export default defineAppConfig({
  layer: {
    name: "AP-004",
  },
  ui: {
    colors: {
      // NOTE: Sesuaikan dengan skema warna pada undangan
      primary: "wistful",
      neutral: "slate",
    },

    toast: {
      slots: {
        title: "font-semibold text-base md:text-base",
        description: "font-normal font-sans text-neutral-700 md:text-sm",
        icon: "size-6",
      },
    },

    button: {
      slots: {
        base: "h-fit",
      },
      compoundVariants: [
        {
          color: "primary",
          variant: "solid",
          class: "text-inverted bg-primary-700 hover:bg-primary-700/75 active:bg-primary-700/75 disabled:bg-primary-700 aria-disabled:bg-primary-700 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primary",
        },
        {
          color: "primary",
          variant: "soft",
          class: "transition-colors duration-150 text-primary-900 bg-primary-200 hover:bg-primary-700/75 hover:text-primary-50 active:bg-primary-500/75 focus-visible:bg-primary-700 focus-visible:text-primary-50 focus:outline-none data-[active=true]:bg-primary-700 data-[active=true]:text-primary-50 disabled:bg-primary-600/80 disabled:text-primary-50 aria-disabled:bg-primary-600/80 aria-disabled:text-primary-50",
        },
        {
          color: "primary",
          variant: "link",
          class: "underline text-default hover:text-default/75 active:text-default/75 disabled:text-default aria-disabled:text-primary-700 focus:outline-none focus-visible:ring-2 focus-visible:ring-inset focus-visible:ring-primary",
        },
        {
          color: "primary",
          variant: "outline",
          class: "ring ring-inset ring-primary-800/50 text-primary-800 hover:bg-primary-800/10 active:bg-primary-800/10 disabled:bg-transparent aria-disabled:bg-transparent dark:disabled:bg-transparent dark:aria-disabled:bg-transparent focus:outline-none focus-visible:ring-2 focus-visible:ring-primary-800",
        },
        {
          color: "primary",
          variant: "subtle",
          class: "text-primary-950 ring ring-inset ring-primary-500/25 bg-primary-500/10 hover:bg-primary-500/15 active:bg-primary-500/15 disabled:bg-primary-500/10 aria-disabled:bg-primary-500/10 focus:outline-none focus-visible:ring-2 focus-visible:ring-primary-500",
        },
      ],
    },

    alert: {
      compoundVariants: [
        {
          color: "primary",
          variant: "subtle",
          class: {
            root: "bg-primary-600/10 text-primary-800 ring ring-inset ring-primary-600/25",
          },
        },
      ],
    },
  },
  template: clientConfig.template,
});
